import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConsumerState } from '@app/resources/ngrx/states';
import { isNotNullOrUndefined } from '@ep/shared';
import { selectNonConsumerEntities } from '@app/resources/ngrx/adapters';

export const selectNonConsumerState = createFeatureSelector<ConsumerState>('nonConsumer');
export const getNonConsumerEntities = createSelector(selectNonConsumerState, selectNonConsumerEntities);

export const getSelectedNonConsumerId = (state: ConsumerState) => {
  return state.selectedConsumerId;
};
export const selectCurrentNonConsumerId = createSelector(selectNonConsumerState, getSelectedNonConsumerId);

export const hasNonConsumersLoaded = createSelector(selectNonConsumerState, (state) => state.hasLoaded);

export const selectNonConsumers = createSelector(
  getNonConsumerEntities,
  hasNonConsumersLoaded,
  (consumerEntities, hasLoaded) => {
    if (!hasLoaded) return null;
    return Object.values(consumerEntities).filter(isNotNullOrUndefined);
  }
);

export const selectNonConsumersSortedByName = createSelector(
  getNonConsumerEntities,
  hasNonConsumersLoaded,
  (consumerEntities, hasLoaded) => {
    if (!hasLoaded) return null;
    return Object.values(consumerEntities)
      .filter(isNotNullOrUndefined)
      .sort((a, b) => {
        const aIsValued = a.NameFirst?.toUpperCase() === 'VALUED' && a.NameLast?.toUpperCase() === 'CUSTOMER';
        const bIsValued = b.NameFirst?.toUpperCase() === 'VALUED' && b.NameLast?.toUpperCase() === 'CUSTOMER';

        if (aIsValued && !bIsValued) {
          return 1;
        }
        if (!aIsValued && bIsValued) {
          return -1;
        }
        const result = (a.NameFirst ?? '').localeCompare(b.NameFirst ?? '');
        if (result !== 0) {
          return result;
        }
        return (a.NameLast ?? '').localeCompare(b.NameLast ?? '');
      });
  }
);

export const selectCurrentNonConsumer = createSelector(
  getNonConsumerEntities,
  selectCurrentNonConsumerId,
  (consumerEntities, consumerId) => {
    return consumerEntities[consumerId ?? 0];
  }
);
